import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: 1,
    position: 'absolute',
    top: '-6px',
    right: '22px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px solid #F5F6F8',
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    cursor: 'pointer',
    background: '#1F1F1F'
  },

  tooltip: {
    margin: '20px 0 0 0'
  }
}))

export default useStyles
